import { ScrollTrigger } from "gsap/ScrollTrigger";

function RevealFromLeft() {
  const className = "reveal-from-left";
  document.querySelectorAll<HTMLElement>(`.${className}`).forEach((el) => {
    const start = el.getAttribute("gsap-start") || "center 95%";
    ScrollTrigger.create({
      trigger: el,
      start,
      once: true,
      toggleClass: `${className}--animated`,
    });
  });
}
function RevealFromRight() {
  const className = "reveal-from-right";
  document.querySelectorAll<HTMLElement>(`.${className}`).forEach((el) => {
    const start = el.getAttribute("gsap-start") || "center 95%";
    ScrollTrigger.create({
      trigger: el,
      start,
      once: true,
      toggleClass: `${className}--animated`,
    });
  });
}
function RevealFromBottom() {
  const className = "reveal-from-bottom";
  document.querySelectorAll<HTMLElement>(`.${className}`).forEach((el) => {
    const start = el.getAttribute("gsap-start") || "center 95%";
    ScrollTrigger.create({
      trigger: el,
      start,
      once: true,
      toggleClass: `${className}--animated`,
    });
  });
}

function BarFromCenter() {
  const className = "bar-from-center";
  document.querySelectorAll<HTMLElement>(`.${className}`).forEach((el) => {
    const start = el.getAttribute("gsap-start") || "center 95%";
    ScrollTrigger.create({
      trigger: el,
      start,
      once: true,
      toggleClass: `${className}--animated`,
    });
  });
}

function FadeInScale() {
  const className = "fade-in-scale";
  document.querySelectorAll<HTMLElement>(`.${className}`).forEach((el) => {
    const start = el.getAttribute("gsap-start") || "center 95%";
    ScrollTrigger.create({
      trigger: el,
      start,
      once: true,
      toggleClass: `${className}--animated`,
    });
  });
}

// function AnimatedPath() {
//   document.querySelectorAll('.animated-path').forEach((path: any) => {
//       path.style.strokeDasharray = path.getTotalLength();
//       path.style.strokeDashoffset = path.getTotalLength();
//   });
// }

export default function Animations() {
  RevealFromLeft();
  RevealFromRight();
  RevealFromBottom();
  BarFromCenter();
  FadeInScale();
  // AnimatedPath();
}
